import useTitle from "hooks/useTitle";
import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import useErrorHandle from "hooks/useErrorHandle";
import EmptyState from "ds/components/EmptyState";
import { Policy } from "components/icons/generated";
import { SpacesContext } from "views/Account/SpacesProvider";

import PoliciesViewHeader from "../ViewHeader";
import PoliciesTemplatesFiltersLayout from "./FiltersLayout";
import { showPoliciesTemplatesTypesDrawer } from "./TypesDrawer";
import { showPoliciesTemplatesInfoDrawer } from "./InfoDrawer";
import useSearchTemplates from "./useSearchTemplates";
import useSearchTemplatesSuggestions from "./useSearchTemplatesSuggestions";
import useTakenPolicyNames from "../useTakenPolicyNames";
import PoliciesTemplatesTable from "./Table";

const PoliciesTemplates = () => {
  const { accountName } = useTypedContext(AccountContext);
  const { hasEntityCreateAccess: canManagePolicies } = useTypedContext(SpacesContext);

  useTitle(`Policies templates · ${accountName}`);

  const {
    entities,
    error,
    isPageEmpty,
    hasNoFilteringResults,
    loading,
    loadMoreItems,
    hasNextPage,
  } = useSearchTemplates();

  const {
    filters,
    filtersMap,
    sortOptions,
    loading: filtersLoading,
    refetchActiveSections,
    filteredCount,
  } = useSearchTemplatesSuggestions();

  const takenPolicyNames = useTakenPolicyNames();

  const ErrorContent = useErrorHandle(error);

  if (ErrorContent) {
    return ErrorContent;
  }

  return (
    <>
      <PoliciesViewHeader />
      <PoliciesTemplatesFiltersLayout
        openPolicyTypesDrawer={showPoliciesTemplatesTypesDrawer}
        openPolicyInfoDrawer={showPoliciesTemplatesInfoDrawer}
        isPageEmpty={isPageEmpty}
        renderedEntitiesCount={entities.length}
        loadingIndication={loading}
        filters={filters}
        filtersMap={filtersMap}
        sortOptions={sortOptions}
        filtersLoading={filtersLoading}
        refetchActiveSections={refetchActiveSections}
        filteredCount={filteredCount}
      >
        {hasNoFilteringResults && (
          <EmptyState title="No results" icon={Policy} caption="Try different filters." announce />
        )}
        {!!entities.length && (
          <PoliciesTemplatesTable
            data={entities}
            loading={loading}
            canManagePolicies={canManagePolicies}
            takenPolicyNames={takenPolicyNames}
            onLoadMore={hasNextPage ? loadMoreItems : undefined}
          />
        )}
      </PoliciesTemplatesFiltersLayout>
    </>
  );
};

export default PoliciesTemplates;
